<template>
    <div class="apply-login-wrap">
        <div class="form-popup-title">{{ $t('LOG_IN_YOURSEL') }}</div>
        <LoginTextInput
            :errors="errors"
            :label="$t('PLACEHOLDER_EMAIL')"
            @enter="submit"
            autocomplete="username"
            icon="mail"
            name="mail"
            style="margin-top: 2rem"
            v-model.trim="mail"
        />
        <LoginTextInput
            :errors="errors"
            :label="$t('LABEL_PASS')"
            @enter="submit"
            autocomplete="password"
            icon="lock"
            name="password"
            type="password"
            v-model.trim="password"
        />
        <ActionButton
            :loading="loading"
            @click="submit"
            style="margin-top: 2rem"
            label="BUTTON_LOGIN"
        />
        <div class="login-actions-row" @click="goBack">
            <span class="login-action">{{ $t('BUTTON_BACK') }}</span>
        </div>
    </div>
</template>
<script>
export default {
    components: {
        LoginTextInput: () => import('../../components/forms/LoginTextInput')
    },
    props: {
        vars: {
            type: Array,
            required: true,
            default: () => {
                return []
            }
        }
    },
    data() {
        return {
            mail: '',
            password: '',
            errors: new this.$Errors(),
            loading: false
        }
    },
    computed: {
        cleanMail() {
            return this.$Utils.clearMail(this.mail)
        }
    },
    methods: {
        async submit() {
            if (!this.validateSubmit()) {
                return
            }
            this.loading = true
            try {
                await this.checkLogin()
                await this.applyForm()
                this.$emit('applied')
                this.loading = false
            } catch (error) {
                this.$Network.handleError(error)
                this.loading = false
            }
        },
        async applyForm() {
            const data = {
                mail: this.cleanMail,
                vars: this.vars
            }
            const sid = this.$route.params.sid
            const uuid = this.$route.params.uuid
            return this.$api.post(
                `v1/contracts/apply-existing/${sid}/${uuid}`,
                data
            )
        },
        checkLogin() {
            const data = {
                mail: this.cleanMail,
                password: this.password
            }
            return this.$api
                .post('v1/accounts/login', data)
                .then(({ data }) => {
                    this.$store.commit('setJWT', data.roles[0].jwt)
                })
        },
        validateSubmit() {
            this.errors.errors = []
            if (!this.password) {
                this.errors.set('password')
            }
            if (!this.mail) {
                this.errors.set('mail')
            }
            if (this.errors.errors.length > 0 || this.loading) {
                return
            }
            return true
        },
        goBack() {
            this.$emit('goBack')
        }
    }
}
</script>
<style lang="scss" scoped>
.apply-login-wrap {
    margin: 0 auto;
    width: 80%;
    display: flex;
    flex-direction: column;

    @media (max-width: 1000px) {
        width: 100%;
    }
}
.form-popup-title {
    font-size: 2rem;
    font-family: $input-family;
    color: $input;
}
</style>
